<template>
  <div class="vz-individual-order-directions pdf-order-section">
    <div class="vz-individual-order-directions-title text-h1 mb-20">
      Отправление
    </div>
    <vz-loader :status-loader="pageLoader" />
    <vz-dispatch-direction>
      <template #switch-append>
        <div v-if="hasPickupInfo" class="vz-multi-order-direction-pickup-info">
          <vz-icon
            name="information-outline"
            size="22"
          />
          <div>
            После оформления мультизаявки будет доступна опция "Групповой забор", что позволит существенно сэкономить на перевозке.
            <nuxt-link
              :to="{ name: 'free-group-pickup' }"
              class="text-decoration-underline"
              target="_blank"
            >
              Подробнее
            </nuxt-link>
          </div>
        </div>
      </template>
    </vz-dispatch-direction>
    <vz-order-members
      use-send-code
      direction="dispatch"
      title-card="Отправитель"
      class="vz-direction-card"
    />
  </div>
</template>

<script setup lang="ts">
import {useLayoutStore} from '~/stores/personal/layout';
import {storeToRefs} from 'pinia';
import VzDispatchDirection from '~/components/personal/order/direction/vz-dispatch-direction.vue';
import VzLoader from '~/components/ui-kit/vz-loader.vue';
import {useOrderStore} from '~/stores/order';
import VzOrderMembers from '~/components/personal/order/members/vz-order-members.vue';
import VzIcon from '~/components/ui-kit/vz-icon.vue';

const { pageLoader } = storeToRefs(useLayoutStore())
const { orderForm } = storeToRefs(useOrderStore())

const hasPickupInfo = computed(() => {
  return orderForm.value.directions.dispatch.direction === 'address'
})
</script>

<style lang="scss" scoped>
.vz-multi-order-direction-pickup-info {
  display: flex;
  gap: 5px;
  align-items: flex-start;
  padding: 16px 24px;
  margin-top: -10px;
  margin-bottom: 20px;
  font-size: $fs-12;
  background-color: $box-gray;
  border-radius: 4px;
}
</style>
